import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'

export class WbcListDLRPFProductsListApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/WBCLISTDLRPFProductsList',
      requesterInfo,
    })
  }

  public async wbcListDLRPFProductsList(): Promise<any[]> {
    return await this.postAsync<any[]>()
  }
}
